// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"739":"1e5259c7","740":"98ee8802","787":"3f4cf1a7","828":"ba8c4cd2","914":"fbc625c4"}[chunkId] + ".chunk.css";
};